// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2nutZ","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__hoBNq"};